import { Navigate, Outlet } from "react-router-dom";

export default function RequireAuth() {
  const token = localStorage.getItem("access");
  console.log("Access token in RequireAuth:", token);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}